<template>
  <div class="orders">
    <table class="order-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td :colspan="isShowBtn?4:3" class="header-row">
          <div class="header-box">
            <h3>
              {{ $t('GA.number') }}：
              <span>{{ orderInfo.orderNo }}</span>
            </h3>
            <div
              class="look-detail"
              v-if="isShowBtn"
              @click="$router.push({ path: '/order/detail', query: { orderNo: orderInfo.orderNo } })"
            >
              <span>{{$t('GA.viewDetails')}}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="data-row">
          <span class="lable">{{ $t('GA.orderTime') }}：</span>
          {{ orderInfo.createdTime }}
        </td>
        <td class="data-row">
          <span class="lable">{{ $t('GA.totalItems') }}：</span>
          {{ orderInfo.productNumber }}
        </td>
        <!-- <td class="data-row">
          <span class="lable">{{ $t('GA.totalPrice') }}：</span>
          <span style="color:red" v-if="userInfo.status>0">{{ userInfo.symbol + orderInfo.orderPrice }}</span>
          <span style="color:red" v-else>{{$t('GA.ViewPrice')}}</span>
        </td> -->
        <!-- <td class="data-row">
          <span class="lable">{{ $t('GA.linkman') }}：</span>
          {{ orderInfo.consignee }}
        </td>
        <td class="data-row">
          <span class="lable">{{ $t('GA.mobile') }}：</span>
          {{ orderInfo.mobile }}
        </td>-->
      </tr>
      <tr v-if="isShowUser">
        <td class="data-row">
          <span class="lable">{{ $hs('销售员','Salesperson','Vendedor') }}：</span>
          {{ orderInfo.createdUserName }}
        </td>
        <td class="data-row">
          <span class="lable">{{ $hs('销售员邮箱','Salesperson email','Buzón del vendedor') }}：</span>
          {{ orderInfo.createdUserEmail }}
        </td>
        <td class="data-row"></td>
      </tr>
      <!-- <tr>
        <td class="data-row">
          <span class="lable">{{ $t('GA.Email') }}：</span>
          {{ userInfo.email }}
        </td>
        <td class="data-row">
          <span class="lable">{{$t('GA.sendDate')}}：</span>
          {{ orderInfo.sendDate || '-' }}
        </td>

        <td class="data-row">
          <span class="lable">{{$t('GA.expressNumber')}}：</span>
          {{ orderInfo.expressNumber || '-'}}
        </td>
      </tr>-->
      <!-- <tr>
        <td class="data-row">
          <span class="lable">{{ $t('GA.orderStatus') }} ：</span>
          <span :class="orderInfo.orderStatus===0? 'red': 'blue'">{{ orderStatus(orderInfo.orderStatus)}}</span>
        </td>
        <td class="data-row">
          <span class="lable">{{ $t('GA.totalItems') }}：</span>
          {{ orderInfo.productNumber }}
        </td>
        <td class="data-row">
          <span class="lable">{{ $t('GA.totalPrice') }}：</span>
          <span style="color:red">{{ userInfo.symbol + orderInfo.orderPrice }}</span>
        </td>
      </tr>-->
    </table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'orderBox',
  props: {
    orderInfo: {
      type: Object,
      default: () => {}
    },
    isShowBtn: {
      type: Boolean,
      default: () => true
    },
    isShowUser: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    }),
    orderStatus() {
      return status => {
        switch (status) {
          case 0:
            return this.$t('GA.unshipped')
          case 1:
            return this.$t('GA.shipped')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.orders {
  width: 100%;
  margin-bottom: 20px;

  .order-table {
    width: 100%;
    border: solid 1px #e9e9e9;
    border-radius: 5px;

    td {
      padding: 10px 15px;
    }

    .header-row {
      background-color: #f5f5f5;
      .header-box {
        display: flex;
        justify-content: space-between;
      }

      .look-detail {
        font-size: 14px;
        color: #fff;
        background-color: #f2410f;
        border-radius: 4px;
        padding: 2px 4px 3px 8px;
        cursor: pointer;
        transition-duration: 0.2s;
        &:hover {
          background-color: #ff3700;
          transition-duration: 0.2s;
          transform: scale(1.1);
        }
      }

      h3 {
        font-size: 16px;
        font-weight: normal;

        span {
          color: #666;
        }
      }
    }

    .data-row {
      padding: 5px 15px;
      width: 25%;
      font-size: 14px;
      height: 30px;
      line-height: 30px;

      .lable {
        color: #666;
      }
      .red {
        color: #f00;
      }

      .blue {
        color: #1890ff;
      }
      &.btn-list {
        text-align: center;
      }
    }
  }
}
</style>